export default __webpack_public_path__ + "static/media/endorsement-victory-archery-archery.ab71cf6a.png";